import { schema } from 'normalizr';

export const practiceSchema = new schema.Entity('practices');
export const practicesListSchema = new schema.Array(practiceSchema)
